module.exports = __webpack_public_path__ + "img/Eligibility Criteria.34c2ca0d.png";